module.exports = __webpack_public_path__ + "static/media/backArrow.35007aa3.svg";